import { render, staticRenderFns } from "./EPTableDetails.vue?vue&type=template&id=164835ae&"
import script from "./EPTableDetails.vue?vue&type=script&lang=js&"
export * from "./EPTableDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports